<template>
  <b-modal ref="DocumentsTemplatesModal" :title="$t('modal_dialogs.templates')" size="sm">
    <div>
      <ul class="files-list">
        <li v-for="template in templates" :key="template.id" class="file">
          <div class="file-name">{{template.filename}}</div>
          <b-btn size="sm" variant="outline-secondary" @click="downLoadFile(template.id)" class="download"
                 :title="`Download ${template.filename}`">
            <icon name="download"></icon>
          </b-btn>
        </li>
      </ul>
    </div>
    <div slot="modal-footer"></div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  import { getFileNameFromContentDisposition } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { saveAs } from 'file-saver';

  export default {
    props: {
      fileUploadUrl: {
        type: String,
        required: true
      },
      templateType: {
        type: String
      }
    },
    data() {
      return {
        additionalParams: {}
      }
    },
    methods: {
      saveFile(response) {
        const disposition = response.headers.get('content-disposition'),
          fileName = getFileNameFromContentDisposition(disposition, 'template-export');
        saveAs(response.body, fileName);
      },
      async downLoadFile(template_id) {
        const params = {
          template_id,
          ...this.additionalParams
        };
        try {
          let response;
          if (this.templateType === 'operation') {
            response = await this.$http.get(this.fileUploadUrl, {params, responseType: 'blob'})
          } else {
            response = await this.$http.get(`${this.fileUploadUrl}${template_id}/`, {responseType: 'blob'})
          }
          this.saveFile(response);
        } catch (e) {
          notificationsRenderer(e.data, 'error')
        }
      }
    },
    computed: {
      ...mapState('woodware', ['templates'])
    },
    mounted() {
      this.$root.$on('openDocumentsTemplatesModal', async (data = {}) => {
        this.additionalParams = {...data};
        await this.$store.dispatch('woodware/fetchTemplates', this.templateType);
        if (this.$refs['DocumentsTemplatesModal']) {
          this.$refs['DocumentsTemplatesModal'].show();
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openDocumentsTemplatesModal');
    }
  }
</script>

<style scoped lang="scss">
  .files-list {
    margin: 0 auto;
    padding: 0;
  }

  .file {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;

    .file-name {
      display: flex;
      align-items: center;
    }
  }

  .download {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/DocumentsTemplatesModal.vue